import { useLocation, useNavigate } from "react-router";

import { getRoleInitialRoute } from "utils/routes.util";

/**
 * Leaves pages that display only a modal (e.g., a report or patient profile on its own URL).
 * Closes the tab if it was opened specifically for this page; otherwise, navigates back
 * one page or falls back to the user's initial page, rather than the saved previous path,
 * which points to this page.
 * Pass { keepTab: true } to prevent the tab from closing, e.g., while an Undo toast
 * must remain accessible.
 */
const useCloseModalPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return ({ keepTab = false } = {}) => {
    if (!keepTab && window.history.length <= 1) {
      window.close();

      if (window.closed) return;
    }

    if (location.key !== "default") {
      navigate(-1);
      return;
    }

    navigate(getRoleInitialRoute(), { replace: true });
  };
};

export default useCloseModalPage;
